<template>
  <v-dialog :value="show" width="400" @click:outside="cancel">
    <v-card data-test="impersonation">
      <v-card-title class="headline">{{ title }}</v-card-title>

      <v-card-text>
        <v-alert
          v-if="duration && duration < 60"
          dense
          outlined
          icon="warning"
          type="warning"
          class="safety-elevation-3 mb-0"
          style="background-color: white !important"
        >
          {{ $t("instructions.readingDurationWarning") }}
        </v-alert>
      </v-card-text>
      
      <v-card-text v-if="!!text">{{ text }}</v-card-text>
      <v-card-text>
        <v-layout column style="margin-bottom: 10px" align-center>
          <v-text-field
            v-if="withUsername"
            v-model="userId"
            :label="$t('auth.username')"
            required
          ></v-text-field>
          <v-text-field
            v-model="password"
            :label="$t('auth.password')"
            type="password"
            required
            data-test="impersonation-pass"
          ></v-text-field>
          <v-alert
            :value="error"
            type="error"
            class="text-xs-center"
            :icon="false"
          >
            {{ $t("auth.unauthorized") }}
          </v-alert>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey darken-1" text @click="cancel()">{{
          $t("dialog.cancel")
        }}</v-btn>
        <v-btn
          color="primary darken-1"
          text
          @click="confirm()"
          :disabled="disabled"
          data-test="impersonation-confirm"
          >{{ action }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    withUsername: Boolean,
    title: String,
    text: String,
    action: String,
    show: Boolean,
    error: Boolean,
    duration: Number,
  },
  data() {
    return {
      userId: "",
      password: "",
    };
  },
  computed: {
    disabled() {
      return (this.withUsername && this.userId === "") || this.password === "";
    },
  },
  methods: {
    confirm() {
      this.$emit("confirm", {
        userId: this.userId,
        password: this.password,
      });
      this.resetData();
    },
    cancel() {
      this.$emit("cancel");
      this.resetData();
    },
    resetData() {
      this.userId = "";
      this.password = "";
    },
  },
};
</script>

<style>
.center input {
  text-align: center;
}
.v-card__text,
.v-card__title {
  word-break: normal;
}
</style>
